import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCurrentLinkedInMe } from "../api/AppLinkApi";
import { ProfileSkeleton, ProfileDisplay, ConnectedStatus } from "./components";

const LinkedinSetting = ({ appInfo }) => {
  const { t } = useTranslation();

  const [connectedUser, setConnectedUser] = useState({
    picture: "",
    name: t("Anonymous"),
    email: "",
    id: "",
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (appInfo.connected) {
      loadProfile();
    } else {
      setLoading(false);
    }
  }, [appInfo]); // eslint-disable-line react-hooks/exhaustive-deps

  const loadProfile = () => {
    setLoading(true);
    getCurrentLinkedInMe()
      .then((data) => {
        setConnectedUser({
          picture: data?.picture || "",
          name: `${data?.given_name || ""} ${data?.family_name || ""}`.trim() || t("Anonymous"),
          email: data?.email || "",
          id: data?.id || "",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <div className="grid grid-cols-12 gap-4 pb-4">
        <div className="col-span-12 lg:col-span-3">
          <div className={"w-60"}>{t("LinkedIn Profile")}</div>
        </div>
        <div className="col-span-12 lg:col-span-7">
          {appInfo.connected ? (
            loading ? (
              <ProfileSkeleton />
            ) : (
              <ProfileDisplay
                picture={connectedUser.picture}
                name={connectedUser.name}
                email={connectedUser.email}
                id={connectedUser.id}
              />
            )
          ) : (
            <div className="text-sm text-gray-500 py-2">
              {t("You need to connect your account first")}
            </div>
          )}
        </div>
        <div className="col-span-12 lg:col-span-2">{appInfo.connected && <ConnectedStatus />}</div>
      </div>
    </>
  );
};

export default LinkedinSetting;
